<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters,mapActions,mapState } from "vuex"
import Swal from "sweetalert2";
import moment from "moment";
import axios from "axios";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Sales",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
  },
  data() {
    return {
      filterTitle: "Held Sales Report",
      title: "Held Sales Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Held Sales Report",
          active: true,
        },
      ],
      totalRows: 1,
      data:{
        datefrom:'',
        dateto: moment(new Date()).format("YYYY-MM-DD"),
      },
      currentPage: 1,
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      filteredReport: [],
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "details",
          sortable: true,
          label: "",
        },
        {
          key: "dateAdded",
          sortable: true,
          label: "DATE",
        },
        {
          key: "identification",
          sortable: true,
          label: "IDENTIFICATION",
        },
        {
          key: "user",
          sortable: true,
          label: "USER",
        }
      ],
      fields1: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "details",
          sortable: true,
          label: "",
        },
        {
          key: "dateAdded",
          sortable: true,
          label: "DATE",
        },
        {
          key: "identification",
          sortable: true,
          label: "IDENTIFICATION",
        },
        {
          key: "user",
          sortable: true,
          label: "USER",
        },
        {
          key: "branch",
          sortable: true,
          label: "BRANCH",
        }
      ],
    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("saledetails", ["SaveStatus","Sales"]),
    ...mapGetters("sales", ["SaveStatus","AllSaleHeld","Products"]),
    ...mapGetters("auth", ["branchid"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.filteredReport ? this.filteredReport.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.filteredReport ? this.filteredReport.length : 1;
  },
  updated() {
  },
  watch: {
    AllSaleHeld(newValue){
      if(newValue){
        this.FetchfilteredData();
      }
    },
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
            this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchSalesHeld: "sales/fetchAllHeld",
      FetchProducts: "sales/fetchItems",

    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    FetchfilteredData(){
      this.filteredReport = this.AllSaleHeld;
    },
    filterReport() {
      let date2 = this.data.dateto;
      let date1 = this.data.datefrom;
      this.filteredReport = this.AllSaleHeld.filter((element) => {
        if (
          this.data.datefrom != "" &&
          this.data.dateto != ""
        ) {
          this.filterTitle = " Held Sales Report From " +
                this.data.datefrom +
                " To " +
                this.data.dateto;
          return (
            element.filterdate >= date1 &&
            element.filterdate <= date2
          );
        }
        return this.filteredReport;
      });
    },
    Excel_export() {
      axios
        .post("export_heldsales", this.data,{
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "heldsales_report.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          // this.$toast.add({
          //   severity: "success",
          //   summary: "Successful",
          //   detail: "Sales Report Downloaded successfully",
          //   life: 6000,
          // });
          this.spinner = false;
        })
        .catch(() => {
          // this.spinner = false;
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Something wrong",
          //   detail: "Sales Report Download failed",
          //   life: 6000,
          // });
        });
    },    
  },
  created() {
    this.FetchSalesHeld();
    this.FetchProducts();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div v-if="filterTitle">
                <h4>
                  <center>{{ filterTitle }}</center>
                </h4>
              </div>
              <div class="col-3">
                <b-button variant="info" @click="Excel_export()"
                  ><i class="fa fa-download"></i>Export</b-button>
              </div>
              <div class="col-3">
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label>From</label>
                  <input
                    @change="filterReport()"
                    type="date"
                    v-model="data.datefrom"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label>To</label>
                  <input
                    @change="filterReport()"
                    type="date"
                    v-model="data.dateto"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="filteredReport?filteredReport:[]"
                  :fields="branchid==0?fields1:fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>                
                <template #cell(details)="data">
                  <table  class="table">
                    <tbody>
                    <tr v-for="(det,d) in data.item.items" :key="d" width="100%">
                      <td>{{ det.name }}</td>
                      <td>{{ det.quantity }}{{ det.unit }}</td>
                      <td>{{ det.selling?thousandSeperator(det.selling):0 }}</td>
                      <td>{{ det.selling?thousandSeperator(det.selling*det.quantity):0 }}</td>
                    </tr>
                    </tbody>
                  </table>
                </template>
              </b-table>
            </div>
            
            <Loader  v-if="!AllSaleHeld"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
